module.exports = __webpack_public_path__ + "img/block-768.9899053a.jpg";